import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "market-header__content" }
const _hoisted_2 = { class: "market-header__market-select" }

import { computed, type PropType } from 'vue';

import { type MarketModel } from '@exchange/libs/market/service/src';
import { type CurrencyModel } from '@exchange/libs/utils/currency/src';

import MarketHeaderDetails from './MarketHeaderDetails.vue';
import MarketHeaderMarketSelect from './MarketHeaderMarketSelect.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketHeader',
  props: {
  currencies: { type: Object as PropType<Dictionary<CurrencyModel>> },
  defaultFiatCurrency: { type: String, required: true },
  isFutures: { type: Boolean, default: false },
  market: { type: Object as PropType<MarketModel>, required: false },
  marketsList: { type: Array as PropType<Array<MarketModel>>, required: false },
  showMarketList: { type: Boolean, default: false },
},
  emits: ["market-clicked"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const marketId = computed(() => props.market?.id);
const onMarketClicked = (id: string) => {
  emit('market-clicked', id);
};

return (_ctx: any,_cache: any) => {
  const _component_ot_module_container = _resolveComponent("ot-module-container")!

  return (_openBlock(), _createBlock(_component_ot_module_container, {
    class: "market-header",
    "scroll-settings": { overflowVisible: true },
    "with-bottom-padding": true
  }, {
    "main-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (marketId.value)
            ? (_openBlock(), _createBlock(MarketHeaderMarketSelect, {
                key: 0,
                "is-futures": __props.isFutures,
                market: __props.market,
                "markets-list": __props.marketsList,
                "show-market-list": __props.showMarketList,
                onMarketClicked: onMarketClicked
              }, null, 8, ["is-futures", "market", "markets-list", "show-market-list"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(MarketHeaderDetails, {
          market: __props.market,
          currencies: __props.currencies,
          "default-fiat-currency": __props.defaultFiatCurrency
        }, null, 8, ["market", "currencies", "default-fiat-currency"])
      ])
    ]),
    _: 1
  }))
}
}

})